// extracted by mini-css-extract-plugin
module.exports = {"general_error":"OiSBsL","generalError":"OiSBsL"};